import React, { useEffect, useState } from 'react';

interface Props {
}

const Shield: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {

	return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 431.942 431.942"  width={props.style?.width || 25} height={props.style?.height || 25} style={props.style}>
<g>
	<g>
		<path d="M385.731,27.51c0.035-4.418-3.518-8.028-7.936-8.063c-1.152-0.009-2.293,0.231-3.344,0.703
			c-50.385,23.45-109.694,16.419-153.2-18.16c-3.02-2.653-7.54-2.653-10.56,0c-43.689,34.137-102.741,41.137-153.2,18.16
			c-4.03-1.812-8.765-0.013-10.577,4.016c-0.472,1.051-0.712,2.191-0.703,3.344c0,1.68,0.56,166.64,0,221.28
			c-0.32,29.2,67.84,124,165.68,182.08c2.475,1.429,5.525,1.429,8,0c98-58.08,166.16-152.88,165.84-182.08
			C385.171,194.15,385.731,29.19,385.731,27.51z M369.731,248.87c0,17.6-56,106-153.76,165.76
			c-98.08-59.68-153.92-148.08-153.76-165.68c0.48-46.16,0.16-170.4,0-209.6c51.607,18.884,109.222,10.91,153.76-21.28
			c44.538,32.19,102.153,40.164,153.76,21.28C369.731,78.47,369.331,202.79,369.731,248.87z"/>
	</g>
</g>
<g>
	<g>
		<path d="M343.971,76.15c0.035-4.418-3.518-8.028-7.936-8.063c-1.152-0.009-2.293,0.231-3.344,0.703
			c-36.571,17.193-79.719,12.237-111.44-12.8c-3.02-2.653-7.54-2.653-10.56,0c-31.728,24.747-74.583,29.803-111.2,13.12
			c-4.03-1.812-8.765-0.013-10.577,4.016c-0.472,1.051-0.712,2.192-0.703,3.344c0,1.2,0.4,123.36,0,163.84
			c-0.24,22,50.64,93.2,123.68,136.56h0c2.475,1.429,5.525,1.429,8,0c73.2-43.36,124.08-114.56,124.08-136.88
			C343.571,199.51,343.971,77.43,343.971,76.15z M327.971,239.99c0,11.28-40,76.32-112,120c-71.44-43.92-112-108.96-112-120
			c0.56-32.64,0-120,0-152c37.708,13.262,79.514,7.29,112-16c32.486,23.29,74.292,29.262,112,16V239.99z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>

	);
};

export {Shield};